import React, { Fragment, useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";

import withStyles from "isomorphic-style-loader/withStyles";
import {
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import s from "./styles.scss";
import "firebase/compat/auth";

import { validURL } from "../../utils/helpers";
import { isEmpty } from "lodash";

interface UrlInputProps {
  label: string;
  disabled: boolean;
  initialUrl?: string;
  onUrlChange: (string, boolean) => void;
}

function UrlInput(props: UrlInputProps) {
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [httpsFormat, setHttpsFormat] = useState("https://");
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (props.initialUrl) urlChangeHandler(props.initialUrl);
  }, []);

  useEffect(() => {
    const newUrl = isEmpty(url) ? "" : httpsFormat + url;
    props.onUrlChange(newUrl, validURL(newUrl));
  }, [url, httpsFormat]);

  const formatChangeHandler = e => {
    setHttpsFormat(e.currentTarget.textContent);
  };

  const urlChangeHandler = url => {
    ["https://", "http://"].forEach(httpsFormat => {
      if (url.includes(httpsFormat)) {
        url = url.replace(httpsFormat, "");
        setHttpsFormat(httpsFormat);
      }
    });
    setUrl(url);
  };

  return (
    <Fragment>
      <label className={s.titleLabel}>
        {props.label}{" "}
        <span data-tip="tooltip-link-url" data-for="tooltip-link-url">
          <i className="fa fa-question-circle" />
        </span>
      </label>
      <InputGroup>
        <Dropdown
          isOpen={dropDownOpen}
          toggle={() => setDropDownOpen(!dropDownOpen)}
        >
          <DropdownToggle
            caret
            color="outline-secondary"
            className={`${s.autoZIndex} ${s.protocolToggle}`}
          >
            {httpsFormat}
          </DropdownToggle>
          <DropdownMenu end>
            <DropdownItem onClick={formatChangeHandler} disabled={props.disabled}>
              https://
            </DropdownItem>
            <DropdownItem divider/>
            <DropdownItem onClick={formatChangeHandler} disabled={props.disabled}>
              http://
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Input
          type="text"
          placeholder="www.example.com"
          value={url}
          onChange={e => urlChangeHandler(e.target.value)}
          disabled={props.disabled}
        />
      </InputGroup>
      <ReactTooltip
        id="tooltip-link-url"
        type="info"
        place="right"
        effect="float"
        delayHide={500}
      >
        Link must begin with{" "}
        <strong style={{ textDecoration: "underline" }}>http://</strong> or{" "}
        <strong style={{ textDecoration: "underline" }}>https://</strong>
      </ReactTooltip>
    </Fragment>
  );
}

export default withStyles(s)(UrlInput);
